// removed by extract-text-webpack-plugin
module.exports = {"block":"AppsCatalog__block-2cOgl","tabs":"AppsCatalog__tabs-3Bou-"};